import { useEffect, useState, useCallback } from 'react';
import axios from 'axios';

const usePeriodos = () => {
  const [periodos, setPeriodos] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchPeriodos = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        'https://intranet.ecotranschile.cl/softland/obtenerPeriodos.php',
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );
      setPeriodos(response.data);
    } catch (error) {
      console.error('Error al obtener periodos:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchPeriodos();
  }, [fetchPeriodos]);

  return { periodos, loading, refetchPeriodos: fetchPeriodos };
};

export default usePeriodos;

